/** Dev-only until the Mortgage Points Calculator design is production-ready. */
export const isMortgagePointsCalculatorEnabled = import.meta.env.DEV;

export const MORTGAGE_POINTS_CALCULATOR_PATH = '/calculators/mortgage-points-calculator';

export const MORTGAGE_POINTS_CALCULATOR_META = {
  title: 'Mortgage Points Calculator: Break-Even & Rate Buydown | Mortgage Compare Calculator',
  description:
    'Calculate how long it takes to break even on discount points or a 2-1 buydown. Enter your loan amount, rates, and upfront cost to see your monthly savings and payoff curve.',
  path: MORTGAGE_POINTS_CALCULATOR_PATH,
} as const;
